<h3 class="title configurator-title">{{ 'closet-doors.finishes.title' | translate }}</h3>
<ng-casto-closet-doors-standard-finishes-doors></ng-casto-closet-doors-standard-finishes-doors>
<ng-casto-closet-doors-standard-finishes-colors></ng-casto-closet-doors-standard-finishes-colors>
<ng-casto-closet-doors-standard-finishes-frames></ng-casto-closet-doors-standard-finishes-frames>
